export const gameStatusEnum = {
  CreatePlayers: 1,
  RevealRoles: 2,
  Questions: 3,
  AdditionalQuestions: 4,
  Voting: 5,
  RevealImposter: 6,
  ImposterAnswer: 7,
  ShowPoints: 8,
  RoundEnd: 9,
};
